import React from "react";
import ReactDOM from "react-dom";
import {BrowserRouter} from "react-router-dom";
import I18nProvider from "components/i18n-provider";
import {Provider} from 'react-redux';
import {store} from "./utils/store";
/**
 ** WARNING: If we import context or provider directly from "components/router", on import it makes circular dependencies
 **/
import Router from "components/router";
import {AuthDataProvider} from "components/auth";
import CinfoKeycloakProvider from "components/cinfo-keycloak-provider";
import {CustomThemeProvider} from "components/mui-providers";
import {CurrentCustomerProvider} from "components/current-customer-context";
import {ApolloProvider} from "components/graphql";
import {TablePaginationProvider} from "components/table";
import {LoadingProvider} from "components/loading-spinner-overlay";
import {ErrorBoundaryGeneric} from "components/error";

const MyApp = () => (
    <ErrorBoundaryGeneric>
        <CinfoKeycloakProvider>
            <AuthDataProvider>
                <I18nProvider>
                    <BrowserRouter>
                        <LoadingProvider>
                            <CustomThemeProvider>
                                <ApolloProvider>
                                    <Provider store={store}>
                                        <CurrentCustomerProvider>
                                            <TablePaginationProvider>
                                                <Router/>
                                            </TablePaginationProvider>
                                        </CurrentCustomerProvider>
                                    </Provider>
                                </ApolloProvider>
                            </CustomThemeProvider>
                        </LoadingProvider>
                    </BrowserRouter>
                </I18nProvider>
            </AuthDataProvider>
        </CinfoKeycloakProvider>
    </ErrorBoundaryGeneric>
);

ReactDOM.render(<MyApp/>, document.getElementById("app"));
